package com.schoolconnect.app.feature.attendance

data class ParentAttendanceChild(
    val id: String,
    val name: String,
    val rollNumber: String,
    val classLabel: String
)

data class ParentAttendanceDay(
    val day: Int,
    val status: ParentAttendanceStatus
)

enum class ParentAttendanceStatus { PRESENT, ABSENT, ABSENT_MORNING, ABSENT_AFTERNOON, LATE, EXCUSED, HOLIDAY, NONE }

data class ParentAttendanceHistoryRow(val date: String, val status: String)
data class ParentAttendanceTrend(val month: String, val percentage: Int, val selected: Boolean = false)

data class ParentAttendanceUiState(
    val children: List<ParentAttendanceChild> = emptyList(),
    val selectedChildIndex: Int = 0,
    val monthOffset: Int = 0,
    val attendancePercentage: Int = 0,
    val presentDays: Int = 0,
    val totalDays: Int = 0,
    val absentDays: Int = 0,
    val todayStatus: String = "—",
    val todayMarkedAt: String = "—",
    val monthLabel: String = "July 2026",
    val calendarStartOffset: Int = 2,
    val calendarDays: List<ParentAttendanceDay> = emptyList(),
    val todayDay: Int? = null,
    val absenceHistory: List<ParentAttendanceHistoryRow> = emptyList(),
    val trend: List<ParentAttendanceTrend> = emptyList(),
    val isLoading: Boolean = false,
    val errorMessage: String? = null
) {
    val selectedChild: ParentAttendanceChild? get() = children.getOrNull(selectedChildIndex)
}

sealed interface ParentAttendanceUiEvent {
    data class ChildSelected(val index: Int) : ParentAttendanceUiEvent
    data object PreviousMonth : ParentAttendanceUiEvent
    data object NextMonth : ParentAttendanceUiEvent
    data object Retry : ParentAttendanceUiEvent
}
